import React from 'react';
import exact from 'prop-types-exact';
import { Col, Row } from 'react-bootstrap';


import PageLayout from '../../../layouts/PageLayout';
import EquipmentTableEnhanced from './components/EquipmentTableEnhanced';
import AddEquipmentButtonEnhanced from './components/AddEquipmentButtonEnhanced';
import { routerProps } from '../../../propTypes';


const propTypes = exact({
  ...routerProps,
});


const EquipmentPage = (props) => {
  const renderPage = () => {
    return (
      <React.Fragment>
        <Row>
          <Col md={12}>
            <div className="pull-right">
              <AddEquipmentButtonEnhanced />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <EquipmentTableEnhanced />
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  return (
    <PageLayout
      title="Equipment List"
      render={renderPage}
    />
  );
};


EquipmentPage.propTypes = propTypes;


export default EquipmentPage;
